/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Detail_Overage_MeteredInputs */



/**
* | output |
* | --- |
* | "Overage metered" |
*
* @param {Partner_Dashboard_Detail_Overage_MeteredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_detail_overage_metered = /** @type {((inputs?: Partner_Dashboard_Detail_Overage_MeteredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Detail_Overage_MeteredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbrauchte Überschreitung")
	return /** @type {LocalizedString} */ ("Overage metered")
});